// apps/app/src/features/Notifications/index.tsx
import { Button } from '@/components/ui/button'
import { IconButton } from '@/components/ui/icon-button'
import * as Popover from '@/components/ui/popover'
import { Text } from '@/components/ui/text'
import { A } from '@solidjs/router'
import { useNotifications } from '@stateApp'
import { Bell } from 'lucide-solid'
import { For, Show, createSignal } from 'solid-js'
import { Portal } from 'solid-js/web'
import { useService } from 'solid-services'
import { Circle, Divider, Flex, Grid } from 'styled-system/jsx'
import NotificationComponent from './Notification'

export default function () {
  const { unreadNotificationsQuery, setNewNotifications, newNotifications } =
    useService(useNotifications)()
  const [isOpen, setIsOpen] = createSignal(false)

  // Use the dedicated unread query data
  const unreadNotifications = () => unreadNotificationsQuery.data || []

  return (
    <Popover.Root
      positioning={{ placement: 'right-end' }}
      closeOnInteractOutside={true}
      open={isOpen()}
      onOpenChange={({ open }) => {
        setNewNotifications(false)
        setIsOpen(open)
      }}
    >
      <Popover.Trigger
        asChild={(triggerProps) => (
          <IconButton
            position="relative"
            {...triggerProps()}
            size="sm"
            style={unreadNotifications().length ? undefined : { color: 'var(--colors-fg-subtle)' }}
            variant={unreadNotifications().length ? 'solid' : 'plain'}
            colorPalette={unreadNotifications().length ? 'jade' : 'gray'}
          >
            <Bell />
            <Show when={newNotifications()}>
              <Circle
                height="2"
                width="2"
                top={2}
                right={2}
                position="absolute"
                background="red.10"
              />
            </Show>
          </IconButton>
        )}
      />
      <Portal>
        <Popover.Positioner>
          <Popover.Content p={0}>
            <Popover.Arrow>
              <Popover.ArrowTip />
            </Popover.Arrow>
            <Grid gap={2}>
              <Show
                when={unreadNotifications().length}
                fallback={<Text p={4}>No new notifications</Text>}
              >
                <Grid gap={3} pt={3} px={3}>
                  <For each={unreadNotifications()}>
                    {(notification) => (
                      <NotificationComponent
                        onAction={(actionType) => {
                          // Keep the popover open unless it is the last notification in the list
                          if (unreadNotifications().length <= 1) {
                            setIsOpen(false)
                          }
                        }}
                        notification={notification}
                      />
                    )}
                  </For>
                </Grid>
              </Show>
              <Divider />
              <Flex justifyContent="end" gap={2} pb={2} px={2}>
                <A href="/notifications">
                  <Button
                    size="xs"
                    onClick={() => setIsOpen(false)}
                    colorPalette="tscGreen"
                    variant="outline"
                  >
                    View All History
                  </Button>
                </A>
              </Flex>
            </Grid>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  )
}
